/**
 * Decides when a project tab the address or a Calendar marker asked for is one
 * this person cannot open, so ProjectDetail can land them on the dashboard
 * instead of a dead end. Tendering is the only role-gated tab a link can reach
 * today; the capability-gated tabs are judged by ProjectDetail's own table.
 */
import { getContractRoleProfile } from '../../contract-administration/roleProfile';
import type { UserRole } from '../../types/auth';
import { isInternalRole } from '../../utils/permissions';

/** Shown when a link or marker asked for a tab this person cannot open and they were sent to the overview. */
export const PROJECT_TAB_UNAVAILABLE_MESSAGE = 'That part of the project is not available to you, so the overview is shown instead.';

export interface ProjectAppointment {
  actingFor?: string | null;
  appointment?: string | null;
}

/** Contract Group staff whose appointment on the project runs the tender. */
export function userRunsTender(role: string | undefined, project: ProjectAppointment): boolean {
  if (!isInternalRole(role as UserRole)) return false;
  return getContractRoleProfile({ actingFor: project.actingFor, appointment: project.appointment }).capabilities.runsTender;
}

export interface TabRedirectInput {
  activeTab: string;
  /** Permissions still loading: never redirect on a guess. */
  permissionsLoading: boolean;
  /** Project row not loaded yet, so the appointment is unknown. */
  projectLoaded: boolean;
  capabilityAllowed: boolean;
  runsTender: boolean;
}

export function projectTabRedirect(input: TabRedirectInput): 'overview' | null {
  if (input.activeTab === 'overview' || input.permissionsLoading) return null;
  if (!input.capabilityAllowed) return 'overview';
  if (input.activeTab === 'tendering' && input.projectLoaded && !input.runsTender) return 'overview';
  return null;
}
